/**
 * @typedef TopicProfilePivot
 * @property {number} topicId
 * @property {number} profileId
 * @property {number} topicOrder
 * @property {number} profileOrder
 */

/**
 *  @external marxism
 *  @property {Object[]} topicCategories
 *  @property {Object[]} profileCategories
 *  @property {TopicProfilePivot[]} topicProfilePivots
 */

const topicPrototype = {

};

const profilePrototype = {
    get hasMoreInfo() {
        return this.introLong || this.topics.length;
    }
};

const topicCategoryPrototype = {

};

const profileCategoryPrototype = {

};

function prototypeObject(prototype) {
    return (object) => Object.assign(Object.create(prototype), object);
}

function buildTopicCategoryTree(categories) {
    const index = {};
    for (const c of categories) {
        c.children = [];
        c.depth = 0;
        index[c.id] = c;
    }

    const root = [];
    for (let category of categories) {
        if (category.parent === 0) {
            root.push(category);
        } else {
            category.parent = index[category.parent];
            category.parent.children.push(category);

            let d = category.depth + 1;
            // noinspection LoopStatementThatDoesntLoopJS
            while (category.parent) {
                if (category.parent.depth < d) {
                    category.parent.depth = d;
                    [category, d] = [category.parent, category.depth + 1];
                }
                break;
            }
        }
    }
    return root;
}

marxism.topics = {};

marxism.topicCategories = marxism.topicCategories.map(prototypeObject(topicCategoryPrototype));

marxism.topicCategories.forEach(category => {
    category.topics = category.topics.map(prototypeObject(topicPrototype));
});
marxism.profileCategories = marxism.profileCategories.map(prototypeObject(profileCategoryPrototype));

marxism.profileCategories.forEach(category => {
    category.profiles = category.profiles.map(prototypeObject(profilePrototype));
});

marxism.topTopicCategories = buildTopicCategoryTree(marxism.topicCategories);

for (const category of marxism.topicCategories) {
    // 카테고리 계보
    category.path = [];
    for (let c = category; c; c = c.parent) category.path.push(c);
    category.path.reverse();

    // 카테고리에 직접 속한 토론
    category.directlyBelongedTopics = category.topics.filter(topic => {
        return category.children.every(child => !child.topics.find(t => t.id === topic.id));
    });

    // 토론에 추가할 데이터 초기화
    for (const topic of category.topics) {
        topic.topicCategories = [];
        topic.directlyBelongingCategories = [];
        topic.profiles = [];
        marxism.topics[topic.id] = topic;
    }
}

for (const category of marxism.topicCategories) {
    // 토론 -> 카테고리 연결
    for (const topic of category.topics) {
        topic.topicCategories.push(category);
        topic.profiles = [];
    }

    // 토론이 직접 속한 카테고리 연결
    for (const topic of category.directlyBelongedTopics) {
        topic.directlyBelongingCategories.push(category);
    }
}



marxism.profiles = {};
marxism.defaultProfiles = [];
for (const category of marxism.profileCategories) {
    // 연사 정보 카테고리와 연결
    for (const profile of category.profiles) {
        marxism.profiles[profile.id] = profile;
        profile.topics = [];
        if (profile.isDefault === 'Y') {
            marxism.defaultProfiles.push(profile);
        }
    }
}

// 토론과 연사 연결
marxism.topicProfilePivots.sort((a, b) => a.topicOrder - b.topicOrder);
for (const {profileId, topicId} of marxism.topicProfilePivots) {
    if (typeof marxism.topics[topicId] !== 'undefined') {
        marxism.profiles[profileId].topics.push(marxism.topics[topicId]);
    }
}

// 연사와 토론 연결
marxism.topicProfilePivots.sort((a, b) => a.profileOrder - b.profileOrder);
for (const {topicId, profileId} of marxism.topicProfilePivots) {
    if (typeof marxism.topics[topicId] !== 'undefined') {
        marxism.topics[topicId].profiles.push(marxism.profiles[profileId]);
    }
}

